module.exports = __webpack_public_path__ + "static/media/amin-feili.09dfdc5d.jpg";